<template>
  <div>
    <custom-label :item-field-name="label" />

    <v-progress-linear v-if="loadingProducts" indeterminate color="primary" class="mb-3" />

    <div v-if="availableProducts.length > 0">
      <v-row dense>
        <v-col v-for="product in availableProducts" :key="product._id" cols="12" sm="6" lg="4">
          <v-checkbox
            :input-value="isProductSelected(product._id)"
            :label="getProductName(product)"
            :color="error ? 'error' : 'primary'"
            @change="toggleProduct(product)"
            dense
            hide-details="auto"
          />
        </v-col>
      </v-row>
    </div>
    <div v-else-if="!loadingProducts" class="text--secondary">No service products available</div>

    <div v-if="error && errorMessages" class="v-messages error--text mt-2">
      <div class="v-messages__wrapper">
        <div class="v-messages__message">
          {{ Array.isArray(errorMessages) ? errorMessages[0] : errorMessages }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { listServiceProduct } from '@/api/serviceProduct';
import customLabel from '@/components/customFormLabel/customLabel';
export default {
  name: 'ServiceProductSelector',
  components: {
    customLabel,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
    label: {
      type: String,
      default: 'Service Type',
    },
  },
  data() {
    return {
      availableProducts: [],
      selectedProductIds: [],
      loadingProducts: false,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.selectedProductIds = [...newVal];
        }
      },
    },
  },
  async mounted() {
    await this.loadServiceProducts();
  },
  methods: {
    getProductName(product) {
      if (!product || !product.name) return '';

      try {
        const name = typeof product.name === 'string' ? JSON.parse(product.name) : product.name;
        return name.en || name['zh-hk'] || 'Unnamed Product';
      } catch (e) {
        return product.name || 'Unnamed Product';
      }
    },

    async loadServiceProducts() {
      try {
        this.loadingProducts = true;
        const data = await listServiceProduct(api, {
          limit: 1000,
        });

        // Filter only enabled products
        const products = data?.docs || [];
        this.availableProducts = products.filter(product => product.enabled !== false);
      } catch (error) {
        console.error('Error loading service products:', error);
        this.$emit('error', 'Failed to load service products');
      } finally {
        this.loadingProducts = false;
      }
    },

    isProductSelected(productId) {
      return this.selectedProductIds.includes(productId);
    },

    toggleProduct(product) {
      const productId = product._id;
      if (this.selectedProductIds.includes(productId)) {
        // Remove from selection
        this.selectedProductIds = this.selectedProductIds.filter(id => id !== productId);
      } else {
        // Add to selection
        this.selectedProductIds = [...this.selectedProductIds, productId];
      }
      this.emitChange();
    },

    emitChange() {
      // Emit array of ObjectIds for the clinic profile
      this.$emit('input', this.selectedProductIds);
      this.$emit('change', this.selectedProductIds);
    },
  },
};
</script>

<style scoped>
.v-chip {
  margin: 2px;
}
</style>
